import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import WithdrawalModal from './WithdrawalModal';
import withdrawalService from '../../services/withdrawalService';

const WithdrawalButton = ({ project, onWithdrawalSuccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(null);
  const [isLoadingBalance, setIsLoadingBalance] = useState(false);

  const handleOpenModal = async () => {
    setIsLoadingBalance(true);
    try {
      const response = await withdrawalService.getAvailableBalance(project.id);
      setAvailableBalance(response.data.availableBalance);
      setIsModalOpen(true);
    } catch (error) {
      console.error('Failed to get available balance:', error);
      // Still open modal, let user see the error there
      setIsModalOpen(true);
    } finally {
      setIsLoadingBalance(false);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAvailableBalance(null);
  };

  const handleWithdrawalSuccess = (withdrawal) => {
    handleCloseModal();
    if (onWithdrawalSuccess) {
      onWithdrawalSuccess(withdrawal);
    }
  };

  // Only show button if project has funding and is completed
  const canWithdraw = project.current_funding > 0 &&
                     project.status === 'completed';

  if (!canWithdraw) {
    return null;
  }

  return (
    <>
      <button
        onClick={handleOpenModal}
        disabled={isLoadingBalance}
        className="inline-flex items-center gap-2 px-4 py-2 bg-teal-600 hover:bg-teal-700 
                   disabled:bg-teal-400 text-white font-medium rounded-lg transition-colors
                   focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
      >
        {isLoadingBalance ? (
          <Loader2 className="w-4 h-4 animate-spin" />
        ) : (
          <Download className="w-4 h-4" />
        )}
        {isLoadingBalance ? 'Loading...' : 'Withdraw Funds'}
      </button>

      {isModalOpen && (
        <WithdrawalModal
          project={project}
          availableBalance={availableBalance}
          onClose={handleCloseModal}
          onSuccess={handleWithdrawalSuccess}
        />
      )}
    </>
  );
};

export default WithdrawalButton;
